import { getCountryFlag } from '@/pages/home/_config/countries';
import { ECHARTSCOLOR as ECHARTS_COLORS } from '@/pages/intelligence/utils/echartsConst';
import { PER_TYPES, /* REVENUE_TYPES, */ REGION_MARKET_TYPES, ECHART_MULTI_ROWS_COLORS } from '../constants';
import type { IRegionType } from '@/pages/intelligence/types/common';
import type { IGeneralLegendOption } from '@/pages/intelligence/components/GeneralLegend/types';
import type {
  IPerType,
  IRevenueType,
  IStackBarChartMetadata,
  IPieChartMetadata,
  IVisualisAndTablesMetadata,
  IBarItem,
  IListDataItem,
  IMetricItem,
} from '../types';

const legendSorter = (a: IGeneralLegendOption, b: IGeneralLegendOption): number => {
  const aName = a?.name;
  const bName = b?.name;
  const otherArr = ['other', 'Other'];
  if (otherArr.includes(aName)) return 1;
  if (otherArr.includes(bName)) return -1;
  return aName.localeCompare(bName);
};

/**
 * Mobile、Total Market、PC Games、Console Games页面 生成饼状图列表的配置数据
 * @param pieDatas 接口返回的饼状图数据
 * @param option.allDimensionDetailsDatas 所以详细信息（品类 或者 地区）
 * @returns 饼状图组件的配置数据（多个饼图）
 */
function generatePieDatas(pieDatas: any, option: { allDimensionDetailsDatas: any[] }): IPieChartMetadata[] {
  if (!Array.isArray(pieDatas)) return [];
  const { allDimensionDetailsDatas } = option || {};
  const piesMetadatas: IPieChartMetadata[] = [];
  // 第一层遍历维度数据
  for (const pieData of pieDatas) {
    const dimensionKey = pieData?.name_abbr;
    // 当前维度（可以是品类、也可以是地区，Top Genre Per Market的详细数据就是地区、Top Market Per Genre的详细数据就是品类）
    const dimension = pieData?.name;
    const dimensionCN = pieData?.name_cn;
    // 当前维度的详细数据，列表数据
    const dimensionDetailsDatas = pieData?.metrics;
    if (!dimension) continue;
    // 检查是否已存在 当前维度对用的饼状图配置对象
    let pieMetadata: IPieChartMetadata | undefined = piesMetadatas.find((item) => item?.theme === dimension);
    if (!pieMetadata) {
      // 不存在的话，就创建 并且push到metadata.pies数组中
      pieMetadata = {
        themeKey: dimensionKey,
        theme: dimension,
        themeCN: dimensionCN,
        data: [],
      };
      piesMetadatas.push(pieMetadata);
    }
    // 没有详细数据，只需要塞个饼图配置对象即可，无需继续往当前饼图配置对象中塞详细数据了，这里直接进入下一个维度的处理
    if (!Array.isArray(dimensionDetailsDatas)) continue;
    // 第二层遍历当前维度下的 详细数据（可以是品类、也可以是地区，Top Genre Per Market的详细数据就是品类、Top Market Per Genre的详细数据就是地区）
    for (const dimensionDetailData of dimensionDetailsDatas) {
      const name = dimensionDetailData?.metric;
      const nameCN = dimensionDetailData?.metric_cn;
      const value = dimensionDetailData?.Value;
      if (!name) continue;
      const dimensionDetailDataColorIndex = allDimensionDetailsDatas?.findIndex((item) => item === name);
      // 使用和柱状图一样的色卡，使用第二序列
      const usedCardColor = ECHART_MULTI_ROWS_COLORS[1];
      const color = usedCardColor[dimensionDetailDataColorIndex];
      pieMetadata.data.push({
        name,
        nameCN,
        value,
        color,
      });
    }
  }
  return piesMetadatas;
}

/**
 * Mobile Games页面 生成柱状图列表的配置数据
 * @param barDatas 接口返回的柱状图数据
 * @param option.perType 维度类型、品类 或者 地区
 * @param option.regionType 地区类型、Region、Core Markets
 * @param option.allDimensionDetailsDatas 所以详细信息（品类 或者 地区）
 * @returns 柱状图组件的配置数据（多个柱状图）
 */
// function generateBarDatasMobile(
//   dimensionsDatas: any,
//   option: {
//     perType: IPerType;
//     regionType: IRegionType;
//     allDimensionDetailsDatas: any[];
//   },
// ): IStackBarChartMetadata[][] {
//   if (!Array.isArray(dimensionsDatas)) return [];
//   const { perType, regionType, allDimensionDetailsDatas } = option || {};
//   // 柱状图的配置数据，是个二维数据，外层数组代表每一个维度（地区、品类），内层数组代表当前维度下的详细数据（地区、品类）,内外数组代表的意思 刚好是互为相反的
//   const barsMetadatas: IStackBarChartMetadata[][] = [];
//   const date = '';

//   // 第一层遍历维度
//   for (const dimensionData of dimensionsDatas) {
//     const dimension = dimensionData?.name;
//     const dimensionDetailsDatas = dimensionData?.metrics;
//     if (!dimension) continue;
//     // 获取当前维度对应的柱状图配置数据数组（因为是多年分，并且柱状图组件是以数组形式提供数据，所以一个柱状图的配置数据就是一个数组）
//     let barMetadata: IStackBarChartMetadata[] | undefined = barsMetadatas?.find(
//       (item) => item?.[0]?.theme === dimension,
//     );
//     // 如果不存在当前维度对应的柱状图配置数据数组，就创建并且push到barsMetadatas
//     if (!barMetadata) {
//       barMetadata = [];
//       barsMetadatas.push(barMetadata);
//     }
//     // 获取当前维度、当前年份下的 柱状图配置数据数组
//     let barMetadataInner: IStackBarChartMetadata | undefined = barMetadata?.find((item) => item?.label === date);
//     // 如果不存在当前年份的 柱状图配置数据数组，就创建并且push到barMetadata数组中，这里通过地址引用拿到当前维度对应的 配置数据数组
//     if (!barMetadataInner) {
//       barMetadataInner = {
//         theme: dimension,
//         label: date,
//         data: [],
//       };
//       barMetadata.push(barMetadataInner);
//     }
//     // 第二层遍历当前维度下的 详细数据（可以是品类、也可以是地区，Top Genre Per Market的详细数据就是品类、Top Market Per Genre的详细数据就是地区）
//     for (const dateDimensionDetailData of dimensionDetailsDatas) {
//       const name = dateDimensionDetailData?.metric;
//       const value = dateDimensionDetailData?.Value;
//       if (!name) continue;
//       const dateDimensionDetailDataColorIndex = allDimensionDetailsDatas?.findIndex((item) => item?.metric === name);
//       const countryCode = (() => {
//         // 类型为地区时，无法确定具体时哪一个国家，所以不显示国旗
//         if (regionType === REGION_MARKET_TYPES.REGION) return '';
//         // 当维度类型为per market时，不展示国旗
//         return perType === PER_TYPES.MARKET ? '' : dateDimensionDetailData?.metric_abbr;
//       })();
//       // 给当前维度、当前年份下的柱状图配置数据 塞数据，也是通过barMetadataInner的地址应用 获取到当前维度、当前年份下 对应的 配置对象
//       barMetadataInner.data.push({
//         name,
//         value,
//         color: ECHARTS_COLORS[dateDimensionDetailDataColorIndex],
//         // tooltip浮窗中 国旗的img src
//         cover: countryCode ? getCountryFlag(countryCode) : '',
//       });
//     }
//   }

//   return barsMetadatas;
// }

/**
 * Mobile Games页面 生成 柱状图组件的配置数据（多个柱状图）和 饼状图组件的配置数据（多个饼图）
 * @param data 接口返回数据
 * @param option.perType 维度类型、品类 或者 地区
 * @param option.regionType 地区类型、Region、Core Markets
 * @returns 柱状图组件的配置数据（多个柱状图）和 饼状图组件的配置数据（多个饼图）
 */
// function generateVisualisAndTablesMetadataMobile(
//   barData: any,
//   pieData: any,
//   option: {
//     perType: IPerType;
//     regionType: IRegionType;
//   },
// ): {
//   [key: string]: IVisualisAndTablesMetadata;
// } {
//   const result: {
//     [key: string]: IVisualisAndTablesMetadata;
//   } = {};
//   const allDimensionDetailsDatas = barData.list?.[0]?.metrics;
//   const metadata: IVisualisAndTablesMetadata = {
//     bars: generateBarDatasMobile(barData, { ...option, allDimensionDetailsDatas }),
//     pies: generatePieDatas(pieData, { allDimensionDetailsDatas }),
//     tables: [],
//   };
//   return metadata;
// }

/**
 * Total Market、PC Games、Console Games页面 生成柱状图列表的配置数据
 * @param barDatas 接口返回的柱状图数据
 * @param option.perType 维度类型、品类 或者 地区
 * @param option.regionType 地区类型、Region、Core Markets
 * @param option.allDimensionDetailsDatas 所以详细信息（品类 或者 地区）
 * @returns 柱状图组件的配置数据（多个柱状图）
 */
function generateBarDatasOther(
  barDatas: any,
  option: {
    perType: IPerType;
    regionType: IRegionType;
    allDimensionDetailsDatas: any[];
  },
): IStackBarChartMetadata[][] {
  if (!Array.isArray(barDatas)) return [];
  const { perType, regionType, allDimensionDetailsDatas } = option || {};
  // 柱状图的配置数据，是个二维数据，外层数组代表每一个维度（地区、品类），内层数组代表当前维度下的详细数据（地区、品类）,内外数组代表的意思 刚好是互为相反的
  const barsMetadatas: IStackBarChartMetadata[][] = [];
  // 第一层遍历年份数据
  for (let i = 0; i < barDatas.length; i++) {
    const barData = barDatas[i];
    /**
     * 纵向只有1条柱子时，固定从ECHARTS_COLORS配色方案取色
     * 纵向多余1条柱子时，按纵向上的索引 从 ECHART_MULTI_ROWS_COLORS中取对应的配色方案
     */
    const usedCardColor = ECHART_MULTI_ROWS_COLORS[1];
    const colors = barDatas.length === 1 ? usedCardColor : ECHART_MULTI_ROWS_COLORS[i];
    // 年份
    const date = barData?.date;
    // 当前年份的维度数据（维度可能是 地区、品类，Top Genre Per Market的维度就是地区、Top Market Per Genre的维度就是品类）
    const dateDimensionsDatas = barData?.list;
    // 年份可以为空，但是维度数据不能为空，因为某个维度下的数据，可能这个年份没数据，但是别的年份有数据，所以就展示出来有数据的年份下的数据就好了
    if (!Array.isArray(dateDimensionsDatas)) continue;
    // 第二层遍历当前年份下的维度数据
    for (const dateDimensionData of dateDimensionsDatas) {
      const dateDimensionKey = dateDimensionData?.name_abbr;
      const dateDimension = dateDimensionData?.name;
      const dateDimensionCN = dateDimensionData?.name_cn;
      const dateDimensionDetailsDatas = dateDimensionData?.metrics;
      if (!Array.isArray(dateDimensionDetailsDatas)) continue;
      // 获取当前维度对应的柱状图配置数据数组（因为是多年分，并且柱状图组件是以数组形式提供数据，所以一个柱状图的配置数据就是一个数组）
      let barMetadata: IStackBarChartMetadata[] | undefined = barsMetadatas?.find(
        (item) => item?.[0]?.theme === dateDimension,
      );
      // 如果不存在当前维度对应的柱状图配置数据数组，就创建并且push到barsMetadatas
      if (!barMetadata) {
        barMetadata = [];
        barsMetadatas.push(barMetadata);
      }
      // 获取当前维度、当前年份下的 柱状图配置数据数组
      let barMetadataInner: IStackBarChartMetadata | undefined = barMetadata?.find((item) => item?.label === date);
      // 如果不存在当前年份的 柱状图配置数据数组，就创建并且push到barMetadata数组中，这里通过地址引用拿到当前维度对应的 配置数据数组
      if (!barMetadataInner) {
        barMetadataInner = {
          themeKey: dateDimensionKey,
          theme: dateDimension,
          themeCN: dateDimensionCN,
          label: date,
          data: [],
        };
        barMetadata.push(barMetadataInner);
      }
      // 第三层遍历当前年份、当前维度下的 详细数据（可以是品类、也可以是地区，Top Genre Per Market的详细数据就是品类、Top Market Per Genre的详细数据就是地区）
      for (const dateDimensionDetailData of dateDimensionDetailsDatas) {
        const name = dateDimensionDetailData?.metric;
        const nameCN = dateDimensionDetailData?.metric_cn;
        const value = dateDimensionDetailData?.Value;
        if (!name) continue;
        const dateDimensionDetailDataColorIndex = allDimensionDetailsDatas?.findIndex((item) => item === name);
        const countryCode = (() => {
          // 类型为地区时，无法确定具体时哪一个国家，所以不显示国旗
          if (regionType === REGION_MARKET_TYPES.REGION) return '';
          // 当维度类型为per market时，不展示国旗
          return perType === PER_TYPES.MARKET ? '' : dateDimensionDetailData?.metric_abbr;
        })();
        const color = colors?.[dateDimensionDetailDataColorIndex];
        // 给当前维度、当前年份下的柱状图配置数据 塞数据，也是通过barMetadataInner的地址应用 获取到当前维度、当前年份下 对应的 配置对象
        barMetadataInner.data.push({
          name,
          nameCN,
          value,
          color,
          // tooltip浮窗中 国旗的img src
          cover: countryCode ? getCountryFlag(countryCode) : '',
          year: date
        });
      }
    }
  }
  return barsMetadatas;
}

type ILocaleDimension = {
  name: string;
  nameCN: string;
};

/**
 * 将所有指标平铺，用于后续展示颜色对照
 * @param data 可视化柱状图返回的数据
 * @returns 指标的列表
 */
function getAllDimensions(_barData: IBarItem[], _pieData: IListDataItem[]): {
  allDimens: ILocaleDimension[];
  barDimens: ILocaleDimension[];
  pieDimens: ILocaleDimension[];
 } {
  const allDimensCheckMap: {
    [key: string]: boolean;
  } = {};
  const barDimensCheckMap: {
    [key: string]: boolean;
  } = {};
  const pieDimensCheckMap: {
    [key: string]: boolean;
  } = {};
  const allDimens:ILocaleDimension[] = [];
  const barDimens:ILocaleDimension[] = [];
  const pieDimens:ILocaleDimension[] = [];
  _barData.forEach((yearItem: IBarItem) => {
    const list = yearItem?.list || [];
    list.forEach((typeItem: IListDataItem) => {
      const metrics = typeItem?.metrics || [];
      metrics.forEach((metricItem: IMetricItem) => {
        if (!allDimensCheckMap[metricItem.metric]) {
          allDimens.push({
            name: metricItem.metric,
            nameCN: metricItem.metric_cn,
          });
          allDimensCheckMap[metricItem.metric] = true;
        }
        if (!barDimensCheckMap[metricItem.metric]) {
          barDimens.push({
            name: metricItem.metric,
            nameCN: metricItem.metric_cn,
          });
          barDimensCheckMap[metricItem.metric] = true;
        }
      });
    });
  });
  _pieData.forEach((typeItem: IListDataItem) => {
    const metrics = typeItem?.metrics || [];
    metrics.forEach((metricItem: IMetricItem) => {
      if (!allDimensCheckMap[metricItem.metric]) {
        allDimens.push({
          name: metricItem.metric,
          nameCN: metricItem.metric_cn,
        });
        allDimensCheckMap[metricItem.metric] = true;
      }
      if (!pieDimensCheckMap[metricItem.metric]) {
        pieDimens.push({
          name: metricItem.metric,
          nameCN: metricItem.metric_cn,
        });
        pieDimensCheckMap[metricItem.metric] = true;
      }
    });
  });
  return {
    allDimens,
    barDimens,
    pieDimens
  };
};

const getAllLegends = (_allDimens: ILocaleDimension[]): IGeneralLegendOption[] => {
  return _allDimens.map((item, index) => ({
    name: item?.name,
    nameCN: item?.nameCN,
    color: ECHART_MULTI_ROWS_COLORS[1][index]
  })).sort(legendSorter);
}

const getLegends = (_dimens: ILocaleDimension[], _allDimens: IGeneralLegendOption[]) => {
  const dimens:IGeneralLegendOption[] = [];
  _allDimens.forEach((item:IGeneralLegendOption) => {
    const find = _dimens.find(_d => _d?.name === item.name);
    if (find) {
      dimens.push(item);
    }
  })
  return dimens;
}

/**
 * Total Market、PC Games、Console Games页面 生成 柱状图组件的配置数据（多个柱状图）和 饼状图组件的配置数据（多个饼图）
 * @param data 接口返回数据
 * @param option.perType 维度类型、品类 或者 地区
 * @param option.regionType 地区类型、Region、Core Markets
 * @returns 柱状图组件的配置数据（多个柱状图）和 饼状图组件的配置数据（多个饼图）
 */
function generateVisualisAndTablesMetadataOther(
  barData: any,
  pieData: any,
  option: {
    perType: IPerType;
    regionType: IRegionType;
  },
): IVisualisAndTablesMetadata {
  if (!barData) barData = [];
  if (!pieData) pieData = [];
  const {
    allDimens,
    barDimens,
    pieDimens
  } = getAllDimensions(barData, pieData);
  const allDimensKeys = allDimens?.map(item => item?.name);
  const barsMetadatas = generateBarDatasOther(barData, { ...option, allDimensionDetailsDatas: allDimensKeys });
  const piesMetadatas = generatePieDatas(pieData, { allDimensionDetailsDatas: allDimensKeys });
  // 这里是柱状图和饼图的所有类型的合计
  const allLegends = getAllLegends(allDimens);
  // 获取bar的图例
  const barsLegends = getLegends(barDimens, allLegends);
  // 获取pie的图例
  const piesLegends = getLegends(pieDimens, allLegends);
  return {
    bars: barsMetadatas,
    barsLegends: barsLegends,
    pies: piesMetadatas,
    piesLegends: piesLegends,
    tables: [],
  };
}

/**
 * 生成 柱状图组件的配置数据（多个柱状图）和 饼状图组件的配置数据（多个饼图）
 * @param data 接口返回数据
 * @param option.perType 维度类型、品类 或者 地区
 * @param option.revenueType 页面类型
 * @param option.regionType 地区类型、Region、Core Markets
 * @returns 柱状图组件的配置数据（多个柱状图）和 饼状图组件的配置数据（多个饼图）
 */
export function generateVisualisAndTablesMetadata(
  barData: any,
  pieData: any,
  option: {
    perType: IPerType;
    revenueType: IRevenueType;
    regionType: IRegionType;
  },
): IVisualisAndTablesMetadata {
  const { perType, /* revenueType, */ regionType } = option || {};
  // if (revenueType === REVENUE_TYPES.MOBILE)
  //   return generateVisualisAndTablesMetadataMobile(barData, pieData, { perType, regionType });
  return generateVisualisAndTablesMetadataOther(barData, pieData, { perType, regionType });
}
